'use strict';

exports.__esModule = true;
exports.FORMAT_WEBP = exports.FORMAT_PNG = exports.CROP_TYPES = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.buildImageSrc = buildImageSrc;
exports.buildPlaceholderSrc = buildPlaceholderSrc;
exports.getImageFormat = getImageFormat;

var _dom = require('./dom');

var CROP_TYPES = exports.CROP_TYPES = {
  FILL: 'fill',
  FIT: 'fit'
};
var FORMAT_PNG = exports.FORMAT_PNG = 'png';
var FORMAT_WEBP = exports.FORMAT_WEBP = 'webp';

/*
  Wix media docs: https://support.wixmp.com/en/article/image-service-3835799
*/
function buildImageSrc() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      fileName = _ref.file_name,
      oW = _ref.width,
      oH = _ref.height;

  var w = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1000;
  var h = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1000;

  var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref2$quality = _ref2.quality,
      quality = _ref2$quality === undefined ? 80 : _ref2$quality,
      format = _ref2.format,
      _ref2$blur = _ref2.blur,
      blur = _ref2$blur === undefined ? 0 : _ref2$blur,
      _ref2$cropType = _ref2.cropType,
      cropType = _ref2$cropType === undefined ? CROP_TYPES.FIT : _ref2$cropType,
      _ref2$encode = _ref2.encode,
      encode = _ref2$encode === undefined ? false : _ref2$encode;

  var isWebPSupported = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _dom.isWindowAvailable && window.__IS_WEBP_SUPPORTED__;

  if (fileName) {
    if (!format) {
      format = isWebPSupported ? FORMAT_WEBP : getImageFormat(fileName);
    }
    var width = w && w < oW ? w : oW,
        height = h && h < oH ? h : oH;


    return 'https://static.wixstatic.com/media/' + fileName + '/v1/' + cropType + '/w_' + width + ',h_' + height + ',' + (!encode && blur > 0 ? 'blur_' + blur + ',' : '') + 'al_c,q_' + quality + (encode ? ',enc_auto' : '') + '/file.' + format;
  }
  return '';
}

function buildPlaceholderSrc(file, _w, h) {
  var props = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var PLACEHOLDER_WIDTH = 20;
  return buildImageSrc(file, PLACEHOLDER_WIDTH, h, _extends({}, props, { blur: props.encode ? 0 : 3 }));
}

var FILE_EXTENSION_REGEX = /\.(\w+)$/i;
function getImageFormat(fileName) {
  var matches = FILE_EXTENSION_REGEX.exec(fileName);
  return matches ? matches[1] : FORMAT_PNG;
}